module.exports = __webpack_public_path__ + "media/images/favicon/favicon-96x96-d3e4d423620c195faf9f08cde13e431e.png";